var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"lds-facebook",class:{ 'veritcally-aligned': _vm.alignVertically }},[_c('div',{style:({ 'background-color': _vm.overrideColour })}),_vm._v(" "),_c('div',{style:({ 'background-color': _vm.overrideColour })}),_vm._v(" "),_c('div',{style:({ 'background-color': _vm.overrideColour })})]),_vm._v(" "),_c('div',[_c('span',[_vm._v(_vm._s(_vm.getLoadingMessage()))])])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17fae7e2","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./src/components/shared-components/loading-spinner/loading-spinner.html
// module id = null
// module chunks = 